import React, { FC, Fragment, useCallback } from 'react';
import { makeStyles } from '@material-ui/core';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { useHistory } from 'react-router-dom';

import { Routers } from '../config/constants';
import locales from '../locales';
import PageHeaderWrap from '../components/Common/PageHeaderWrap';
import CashBoxWarningCont from '../containers/CashBoxWarning';
import { NoHostessWarning } from '../features';
import TelephonyIntegrationsPage from "./TelephonyIntegrationsPage";
import GatewaysIntegrationsPage from "./GatewaysIntegrationsPage";
import BackIcon from "../components/Common/Icons/BackIcon";
import GuestmeNotificationsPage from "./GuestmeNotificationsPage";
import { useIsRestaurantGuestmeNotifications } from "../selectors/RestaurantSelectors";


const useStyles = makeStyles((theme) => ({
  tabsRoot: {
    minHeight: 64,
    [theme.breakpoints.down('md')]: {
      minHeight: 52,
    },
  },
  tabRoot: {
    minWidth: 180,
    fontSize: '16px',
    minHeight: 64,
    [theme.breakpoints.down('md')]: {
      minWidth: 120,
      minHeight: 52,
      fontSize: '14px',
    },
  },
}));

type PageID = 'gateways' | 'telephony'

const routeMap: {
  [view: string]: string
} = {
  gateways: Routers.gateways,
  telephony: Routers.telephony,
};

interface SettingsPageProps {
  view: PageID;
}

const IntegrationsPage: FC<SettingsPageProps> = ({ view }) => {
  const history = useHistory();
  const classes = useStyles();
  const isGuestmeNotifications = useIsRestaurantGuestmeNotifications();

  const onTabChange = useCallback((event: any, value: string) => {
    if (routeMap[value]) {
      history.push(routeMap[value]);
    }
  }, []);

  const { pathname } = history.location;
  let pageHeaderWithBackButton = null;

  if (
    pathname.indexOf("/gateways") !== -1 &&
    pathname.split("/").filter(p => p.trim()).length > 1
  ) {
    pageHeaderWithBackButton = (
      <PageHeaderWrap isBackButton>
        <BackIcon onClick={() => history.push('/gateways')} style={{ cursor: 'pointer' }} />
        <Tabs
          onChange={onTabChange}
          scrollButtons="off"
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
          centered
          value={view}
          classes={{ root: classes.tabsRoot }}
        >
          <Tab classes={{ root: classes.tabRoot }} label={locales.t('gateways.title')} value="gateways" />
          {/* <Tab classes={{ root: classes.tabRoot }} label={locales.t('telephony.title')} value="telephony" /> */}
        </Tabs>
      </PageHeaderWrap>
    );
  }

  return (
    <Fragment>
      {pageHeaderWithBackButton}

      <CashBoxWarningCont />
      <NoHostessWarning />

      {view === "gateways" && (isGuestmeNotifications ? <GuestmeNotificationsPage /> : <GatewaysIntegrationsPage />)}
      {view === "telephony" && <TelephonyIntegrationsPage />}
    </Fragment>
  );
};

export const GatewaysPage: FC = () => (
  <IntegrationsPage view="gateways" />
);

export const TelephonyPage: FC = () => (
  <IntegrationsPage view="telephony" />
);
